import { render, staticRenderFns } from "./permissions.vue?vue&type=template&id=648ac0e9&scoped=true"
import script from "./permissions.vue?vue&type=script&lang=js"
export * from "./permissions.vue?vue&type=script&lang=js"
import style0 from "./permissions.vue?vue&type=style&index=0&id=648ac0e9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "648ac0e9",
  null
  
)

export default component.exports